import React from "react";

import ModelError from "components/Results/ModelError";

import ModelLoadingIndicator from "containers/Results/ModelLoadingIndicator";

import styles from "./style.module.css";

export default class BusinessResults extends React.PureComponent {
  constructor(props) {
    super(props);
  }

  render() {
    const {
      id,
      isNextStep,
      models,
      model,

      options,
      blueprintId,
      isError,
      errorMessages
    } = this.props;

    if (isError) {
      return <ModelError errors={errorMessages} />;
    }

    return (
      <div className={styles.emptyMsg}>
        <ModelLoadingIndicator id={id} />
      </div>
    );
  }
}
